import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(key, { ns: "validation" });

export const examPrescriptionItemSchema = z.object({
  exam_type_id: z.string().uuid().optional().or(z.literal("")),
  exam_name: z.string().min(1, t("nameRequired")),
  instructions: z.string().optional().or(z.literal("")),
});

export const examPrescriptionSchema = z.object({
  pet_id: z.string().uuid(t("selectPatient")),
  clinic_id: z.string().uuid(t("clinicRequired")),
  appointment_id: z.string().uuid().optional().or(z.literal("")),
  medical_record_id: z.string().uuid().optional().or(z.literal("")),
  type: z.literal("exam"),
  validity_in_days: z.preprocess(
    (value) => {
      if (value === "" || value === null || value === undefined) return undefined;
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === "") return undefined;
        const parsed = Number(trimmed);
        return Number.isNaN(parsed) ? value : parsed;
      }
      return value;
    },
    z.number().int().positive(t("validityDaysRequired")).max(365).optional(),
  ),
  observations: z.string().optional().or(z.literal("")),
  items: z.array(examPrescriptionItemSchema).min(1, t("atLeastOneExam")),
});

export const examPrescriptionTemplateSchema = z.object({
  title: z.string().min(1, t("titleRequired")),
  observations: z.string().optional().or(z.literal("")),
  items: z.array(examPrescriptionItemSchema).min(1, t("atLeastOneExam")),
});

export type ExamPrescriptionItemInput = z.infer<typeof examPrescriptionItemSchema>;
export type ExamPrescriptionInput = z.infer<typeof examPrescriptionSchema>;
export type ExamPrescriptionTemplateInput = z.infer<typeof examPrescriptionTemplateSchema>;
